module.exports = __webpack_public_path__ + "img/icon-arrow-top.cdf3aba7.svg";